import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './styles.css'

import AdminLayout from './pages/admin/AdminLayout.jsx'
import AdminConfirmPage from './pages/admin/AdminConfirmPage.jsx'
import AdminSettingsPage from './pages/admin/AdminSettingsPage.jsx'
import AdminQueryPage from './pages/admin/AdminQueryPage.jsx'
import AdminYoutubeApiPage from './pages/admin/AdminYoutubeApiPage.jsx'
import AdminYoutubeChannelsApiPage from './pages/admin/AdminYoutubeChannelsApiPage.jsx'
import YoutubeVideosApiPage from './pages/admin/YoutubeVideosApiPage.jsx'
import YoutubeSearchApiPage from './pages/admin/YoutubeSearchApiPage.jsx'
import YoutubeChannelsApiPage from './pages/admin/YoutubeChannelsApiPage.jsx'
import YoutubePlaylistsApiPage from './pages/admin/YoutubePlaylistsApiPage.jsx'
import YoutubePlaylistItemsApiPage from './pages/admin/YoutubePlaylistItemsApiPage.jsx'
import YoutubeCommentThreadsApiPage from './pages/admin/YoutubeCommentThreadsApiPage.jsx'
import YoutubeVideoCategoriesApiPage from './pages/admin/YoutubeVideoCategoriesApiPage.jsx'
import NewsApiPage from './pages/admin/NewsApiPage.jsx'
import StockKeywordPage from './pages/admin/StockKeywordPage.jsx'
import NaverNewsPage from './pages/admin/NaverNewsPage.jsx'
import RealEstateAuctionPage from './pages/admin/RealEstateAuctionPage.jsx'
import YoutubeSummaryPage from './pages/admin/YoutubeSummaryPage.jsx'
import NotFound from './pages/NotFound.jsx'

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/confirm" replace />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="confirm" element={<AdminConfirmPage />} />
          <Route path="settings" element={<AdminSettingsPage />} />
          <Route path="query" element={<AdminQueryPage />} />
          <Route path="youtube-api" element={<AdminYoutubeApiPage />} />
          <Route path="youtube-channels-api" element={<AdminYoutubeChannelsApiPage />} />
          <Route path="youtube-videos-api" element={<YoutubeVideosApiPage />} />
          <Route path="youtube-search-api" element={<YoutubeSearchApiPage />} />
          <Route path="youtube-channels-api-test" element={<YoutubeChannelsApiPage />} />
          <Route path="youtube-playlists-api" element={<YoutubePlaylistsApiPage />} />
          <Route path="youtube-playlist-items-api" element={<YoutubePlaylistItemsApiPage />} />
          <Route path="youtube-comment-threads-api" element={<YoutubeCommentThreadsApiPage />} />
          <Route path="youtube-video-categories-api" element={<YoutubeVideoCategoriesApiPage />} />
          <Route path="news-api" element={<NewsApiPage />} />
          <Route path="stock-keyword" element={<StockKeywordPage />} />
          <Route path="naver-news" element={<NaverNewsPage />} />
          <Route path="real-estate-auction" element={<RealEstateAuctionPage />} />
          <Route path="youtube-summary" element={<YoutubeSummaryPage />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

createRoot(document.getElementById('root')).render(<App />) 